// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3_jxX","stories":"_36LLL","headline":"_15XGv"};